<template>
<div class="component">
    <div class="loadingscreen">
        <div class="loaderContainer">
            <div class="loader "></div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'Loadingscreen',
    props: [],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: []
        }
    },
    methods: {},
    computed: {},
}
</script>

<style scoped>
.loadingscreen {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(1, 1, 1, 0.8);
    z-index:999;

}

.loader {
    border: 3vw solid #f3f3f3;
    /* Light grey */
    border-top: 3vw solid #5CEBC7;
    /* Blue */
    border-radius: 50%;
    width:20vw;
    height: 20vw;
    animation: spin 1.5s linear infinite;
}

.loaderContainer {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top:50%;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
